import React, { ReactNode } from 'react';
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuth } from '../AuthContext';
import { Brand } from './Brand';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleHome = () => {
    navigate('/');
  };

  const handleCosts = () => {
    navigate('/costs');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar
        position="static"
        color="default"
        elevation={1}
        sx={{
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider'
        }}
      >
        <Toolbar>
          <Box
            onClick={handleHome}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <Brand />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Button onClick={handleCosts}>
            Costs
          </Button>
          <Button onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flex: 1 }}>
        {children}
      </Container>
      <Box
        component="footer"
        sx={{
          py: 1.5,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: 'text.secondary' }}
              onClick={() => navigate('/legal')}
            >
              Legal Notice
            </Button>
            <Button
              variant="text"
              size="small"
              sx={{ color: 'text.secondary' }}
              onClick={() => navigate('/privacy')}
            >
              Privacy Policy
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
